const socialImages = document.querySelectorAll('.products')

socialImages.forEach((block) => {
  const list = block.querySelector('.products-list')

  const swiper = new Swiper(list, {
    centerInsufficientSlides: true,
    slidesPerView: 2,
    spaceBetween: 20,
    breakpoints: {
      1024: {
        spaceBetween: 40,
        slidesPerView: 3,
      },
      1200: {
        spaceBetween: 40,
        slidesPerView: 4,
      },
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
  })
})
